var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gn9jbdskea",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cad45e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cad45e"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1793",
    transform: "translate(-550 -318)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 74",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(550 318)",
    style: {
      fill: "url(#gn9jbdskea)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.792 3.437a.671.671 0 0 1-.2.493L6.344 9.175l-.985.985a.7.7 0 0 1-.985 0l-.985-.985L.765 6.552a.7.7 0 0 1 0-.985l.985-.985a.671.671 0 0 1 .493-.2.671.671 0 0 1 .493.2l2.13 2.137 4.753-4.76a.7.7 0 0 1 .985 0l.985.985a.671.671 0 0 1 .2.493z",
    transform: "translate(555.438 324.244)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.709e95b9172a55c8333b6616a9970fc3.svg";
export { ForwardRef as ReactComponent };